import styled from "@yb/styled-px2rem";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";

interface Props extends ButtonProps {
	onClose?: () => void;
}

const Button = styled.button`
	position: relative;
	width: 25px;
	height: 25px;
	background-color: transparent;

	&::before,
	&::after {
		position: absolute;
		top: 0;
		right: 12px;
		display: block;
		width: 2px;
		height: 28px;
		background-color: var(--emp-color);
		content: "";
	}
	&::before {
		transform: rotate(45deg);
	}
	&::after {
		transform: rotate(-45deg);
	}

	> span {
		position: absolute;
		width: 1px;
		height: 1px !important;
		padding: 0;
		margin: -1px;
		border: none;
		clip: rect(0 0 0 0);
		overflow: hidden;
	}
`;

const PopupCloseButton = ({onClose}: Props) => (
	<Button type="button" onClick={onClose}>
		<span>팝업 닫기</span>
	</Button>
);

export default PopupCloseButton;
